export default "/static/webpack/media/undraw_hire.b0f10522.svg";